import { render, staticRenderFns } from "./BrowseReportsDropdown.vue?vue&type=template&id=a4c0169e&scoped=true"
import script from "./BrowseReportsDropdown.vue?vue&type=script&lang=ts"
export * from "./BrowseReportsDropdown.vue?vue&type=script&lang=ts"
import style0 from "./BrowseReportsDropdown.vue?vue&type=style&index=0&id=a4c0169e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c0169e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4c0169e')) {
      api.createRecord('a4c0169e', component.options)
    } else {
      api.reload('a4c0169e', component.options)
    }
    module.hot.accept("./BrowseReportsDropdown.vue?vue&type=template&id=a4c0169e&scoped=true", function () {
      api.rerender('a4c0169e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/BrowseReportsDropdown.vue"
export default component.exports